import { render, staticRenderFns } from "./ProductButtonProductPage.vue?vue&type=template&id=1d3922b7&"
import script from "./ProductButtonProductPage.vue?vue&type=script&lang=js&"
export * from "./ProductButtonProductPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports